export default "__VITE_ASSET__l2Dm3AYY__"